export enum ApplicationType {
    DESKTOP_APP_MAC = 'Desktop app (Mac)',
    DESKTOP_APP_WINDOWS = 'Desktop app (Windows)',
    MOBILE_APP_IOS = 'Mobile app (iOS)',
    MOBILE_APP_ANDROID = 'Mobile app (Android)',
    VIRTUAL_APP_SMARTWEB = 'Virtual app (Smartweb)',
    WEB_APP_WEBSITE = 'Web app (Website)',
    EXTENSION = 'Extension'
}